import { Component, EventEmitter, Input, Output, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MediaType } from 'src/app/models/enums/MediaType.enum';
import { Video } from 'src/app/models/types/Product/Product.type';
import { ToastService } from 'src/app/services/toast.service';
import { ModalComponent } from '../../modal/modal.component';
import { VideoComponent } from '../video/video.component';

@Component({
  selector: 'app-media-preview',
  imports: [
    TranslateModule,
    VideoComponent
  ],
  templateUrl: './media-preview.component.html',
  styleUrl: './media-preview.component.scss'
})
export class MediaPreviewComponent {
  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  @Input('selectedMedia') selectedMedia!: Signal<string>;
  @Input('selectedVideo') selectedVideo!: Signal<Video | undefined>;
  @Input('selectedMediaType') selectedMediaType!: MediaType;
  @Input('canShowImageButton') canShowImageButton!: boolean;
  @Input('canShowVideoButton') canShowVideoButton!: boolean;
  @Input('canShowModel3DButton') canShowModel3DButton!: boolean;

  @Output('handleSelectMediaType') handleSelectMediaType: EventEmitter<MediaType> = new EventEmitter();
  @Output('handleOpenFullScreenModal') handleOpenFullScreenModal: EventEmitter<boolean> = new EventEmitter();

  constructor(private readonly toastService: ToastService) { }

  public openedModal: WritableSignal<boolean> = signal(false);

  public get MediaType() {
    return MediaType;
  }

  public get showToolbar(): boolean {
    return this.canShowImageButton || this.canShowVideoButton || this.canShowModel3DButton;
  }

  public handlePlay() {
    this.openModal();
  }

  openModal() {
    this.openedModal.set(true);
    this.modal.buildModal(() => {
      this.openedModal.set(false);
    }, "lg");
  }

  goToFullScreen() {
    this.handleOpenFullScreenModal.emit(true);
  }

  // _copyImageToClipboard(): void {
  //   const imageUrl = this.selectedMedia();
  //   if (!imageUrl) return;

  //   fetch(imageUrl, {
  //     headers: {
  //       'Access-Control-Allow-Origin': '*'
  //     }
  //   })
  //     .then(response => response.blob())
  //     .then(blob => {
  //       const item = new ClipboardItem({ [blob.type]: blob });
  //       navigator.clipboard.write([item]);
  //       this.toastService.showInfo("Image copied");
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       this.toastService.showError('Failed to copy image');
  //     });
  // }

  // async copyImageToClipboard() {
  //   const imageUrl = this.selectedMedia();
  //   if (!imageUrl) return;
  //   try {
  //     const data = await fetch(imageUrl);
  //     const blob = await data.blob();
  //     await navigator.clipboard.write([
  //       new ClipboardItem({
  //         [blob.type]: blob
  //       })
  //     ]);
  //     console.log('Image copied.');
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }
}
